
import React, { Fragment } from 'react'
import { useLocation, Route, Routes, Navigate } from 'react-router-dom'

import routes from '../routes.js'

const PublicLayout = () =>
{
	const getRoutes = (routes) =>
	{
		return routes.map((prop, key) =>
		{
			if (prop.collapse)
			{
				return getRoutes(prop.views)
			}
			if (prop.layout === '/public')
			{
				return (
					<Route path={prop.path} element={prop.component} key={key} exact/>
				)
			}
			else
			{
				return null
			}
		})
	}
	
	return (
		<Fragment>
			<div className="app-container">
				<Routes>
					{ getRoutes(routes) }
					<Route path="*" element={ <Navigate to="/public/login" replace /> } />
				</Routes>
			</div>
		</Fragment>
	)
}

export default PublicLayout
